import React from 'react'
import { Link } from "react-router-dom";

function About(props) {
  return (
    <div>
    <h1>About</h1>
    <p>This is an app for learning the Arabic abjad. </p>
    <p>It's built in React. </p>
    <p>For questions please refer to <a href="mailto:ds222qe@student.lnu.se">my mail.</a></p>
    <Link to="/">
  <div className="ArticleButtonBox">  Go back</div>
    </Link>
    </div>
  )
}

export default About
